/* Auction Clearance 1.4 — preserve preview context, never inherit a directory view
 * when opening a brand/fandom collection. Store data remains read-only. */
(() => {
  'use strict';
  const bound = new WeakSet();
  const keepPreview = (target, current) => {
    ['preview_theme_id', '_fd', 'pb'].forEach(key => {
      if (current.searchParams.has(key)) target.searchParams.set(key, current.searchParams.get(key));
    });
  };
  function setupGift(form) {
    if (bound.has(form)) return;
    bound.add(form);
    form.addEventListener('submit', event => {
      const select = form.querySelector('[data-gift-destination]');
      if (!select?.value) return;
      const current = new URL(location.href);
      const target = new URL(select.value, location.origin);
      if (target.origin !== current.origin) return;
      event.preventDefault();
      for (const [name, value] of new FormData(form)) {
        if (name.startsWith('filter.') && String(value).trim()) target.searchParams.set(name, value);
      }
      keepPreview(target, current);
      location.assign(target.href);
    });
  }
  function preserveControlLinks(scope) {
    const current = new URL(location.href);
    scope.querySelectorAll('[data-ac-collection] .ac-filter-reset, [data-ac-collection] .ac-active-filters a, [data-ac-collection] [data-stock-pagination] a').forEach(link => {
      const target = new URL(link.href, location.origin);
      if (target.origin !== current.origin) return;
      if (current.pathname.includes('/collections/')) {
        target.pathname = current.pathname;
        const view = current.searchParams.get('view');
        if (view?.startsWith('fandom-') || view === 'other-fandoms') target.searchParams.set('view', view);
      }
      keepPreview(target, current); link.href = target.href;
    });
  }
  function preservePreviewLinks(scope) {
    const current = new URL(location.href);
    if (!current.searchParams.has('preview_theme_id')) return;
    scope.querySelectorAll('a[href]').forEach(link => {
      try {
        if (link.getAttribute('href')?.startsWith('#')) return;
        const target = new URL(link.href, location.origin);
        if (target.origin !== current.origin || !/^https?:$/.test(target.protocol)) return;
        if (/\/(admin|checkout|checkouts|account|cart)(\/|$)/.test(target.pathname)) return;
        keepPreview(target, current); link.href = target.href;
      } catch (_) { /* A malformed optional external link cannot break the storefront. */ }
    });
    // A normal search/filter form must also remain on the unpublished theme.
    scope.querySelectorAll('form[method="get"]').forEach(form => {
      const target = new URL(form.action, location.origin);
      if (target.origin !== current.origin) return;
      ['preview_theme_id', '_fd', 'pb'].forEach(name => {
        if (!current.searchParams.has(name)) return;
        let field = form.querySelector(`input[name="${name}"]`);
        if (!field) { field = document.createElement('input'); field.type = 'hidden'; field.name = name; form.append(field); }
        field.value = current.searchParams.get(name);
      });
    });
  }
  function init(scope = document) {
    scope.querySelectorAll('[data-fandom-gift]').forEach(setupGift);
    preserveControlLinks(scope); preservePreviewLinks(scope);
  }
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('ac:collection-sorted', () => init(document));
  init();
})();
